import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingExpansions = function () { return utilBalancing.getBalancing().Expansions; };
export var selectBalancingExpansionsByFarmId = function (baseId) {
    return selectBalancingExpansions().find(function (group) { return group.farmId === baseId; });
};
export var balancingExpansionsMemoizedFunctions = [selectBalancingExpansions];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingExpansions.ts
// module id = 674
// module chunks = 3